"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";

import "./select.css";

export function BlogSort() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const currentSort = searchParams.get("sort") || "recent";

  const handleSortChange = (sortOrder: string) => {
    const params = new URLSearchParams(searchParams);
    params.set("sort", sortOrder);
    router.push(`${pathname}?${params.toString()}`);
  };

  return (
    <select
      value={currentSort}
      onChange={(e) => handleSortChange(e.target.value)}
      className="select-custom text-sm h-12 px-4 pr-10 rounded-2xl border focus:ring-0 focus:outline-none text-gray-900 placeholder-neutral-400 appearance-none"
    >
      <option value="desc">Mais Recentes</option>
      <option value="asc">Mais Antigas</option>
    </select>
  );
}
